<template>
    <div v-if="show">
        <div>
            <div
              id="dropZone"
              
              @dragover.prevent="onDragOver"
              @dragleave.prevent="onDragLeave"
              @drop.prevent="onDrop"
              @click="openFileDialog"
            >
              <p>Drop files here or click to upload</p>
            </div>
            <input
              type="file"
              ref="fileInput"
              multiple
              style="display: none"
              @change="handleFiles($event)"
              accept=".jpg, .jpeg, .png, .doc, .docx, .pdf"
            />
           
          </div>
          <div v-if="imagePreviews.length" class="preview-container">
            
        <span v-for="(image, index) in imagePreviews" :key="index" class="image-preview">
          <span class="preview-remove"><v-icon color="error" @click="removeFile(index)">mdi-progress-close</v-icon></span>
          <img :src="image" alt="Preview" />
        </span>
        
      </div>
            
      <div class="text-center mt-4" v-if="imagePreviews.length">
        <div class="mb-4" v-if="uploading">
          <v-progress-linear
              color="success"
              height="6"
              indeterminate
              rounded
            ></v-progress-linear>
            <span class="text-disabled">Uploading files <span id="upload-progress">{{ upload_status }}</span>....</span>
          </div>
  
        <v-btn small @click="FileUpload" :loading="uploading">UPLOAD</v-btn>
      </div>
      <div v-if="uploadedfiles.length" class="preview-container">
            <span v-for="(image, index) in viewUploadedfiles()" :key="index" class="image-preview">
              <img :src="image" alt="Preview" />
            </span>
            
          </div>
     </div>
   </template>
   <script>
  
   import {
     mapMutations
   } from 'vuex'
     export default {
        props: {
            show: {
                type: Boolean,
                default: false
            }
        },
       data: () => ({
        storage:'',
        uploading: false,
        allowed_files:'',
        accetedFiles:[],
        uploadedfiles:[],
        imagePreviews: [],
        upload_status:''
       }),
       created() {
        this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.SETVARS()
          setTimeout(()=>{
            this.storage = this.GET_SYSVARS('storage')
            this.allowed_files = this.GET_SYSVARS('allowed_files')
          },2000)
  
       },
        watch: {
            show (v) {
                if (v) {
                    this.accetedFiles = []
                    this.uploadedfiles = []
                    this.imagePreviews = []
                } 
            }
        },
       computed:{
       
       },
       methods: {
         ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
         removeFile(index){
          this.accetedFiles.splice(index, 1);
          this.imagePreviews.splice(index, 1);
         },
         // Trigger file dialog when the drop zone is clicked
            openFileDialog() {
              this.$refs.fileInput.click();
            },
  
            // Highlight the drop zone on drag over
            onDragOver() {
              this.isDragOver = true;
            },
  
            // Remove the highlight when the drag leaves the drop zone
            onDragLeave() {
              this.isDragOver = false;
            },
  
            // Handle the drop event
            onDrop(event) {
              this.isDragOver = false;
              const files = event.dataTransfer.files;
              this.validateAndUploadFiles(files);
            },
            viewUploadedfiles(){
              var preview = []
              const imageRegExp = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i;
              for (const file of this.uploadedfiles) {
                  if(imageRegExp.test(file)){
                    preview.push(file)
                  } else {
                    preview.push(this.$store.state.nopreview)
                  }
              }
              return preview
            },
            // Handle files selected via file input
            handleFiles(event) {
              const files = event.target.files;
              this.validateAndUploadFiles(files);
            },
            validateAndUploadFiles(files) {
                const allowedTypes = this.allowed_files
  
                for (const file of files) {
                  if (allowedTypes.includes(file.type)) {
                    console.log('Accepted file:', file.name, file.type);
                   this.accetedFiles.push(file)
                    if (file.type.startsWith('image/')) {
                        this.previewImage(file);
                      } else {
                        this.nopreview();
                      }
                  } else {
                    console.log('File type not allowed:', file.name);
                    alert(`Invalid file type: ${file.name}. Only JPG, PNG, DOC, DOCX, and PDF files are allowed.`);
                  }
                }
              },
          nopreview(){
            this.imagePreviews.push(this.$store.state.nopreview)
          },    
          previewImage(file) {
            const reader = new FileReader();
            reader.onload = (event) => {
              this.imagePreviews.push(event.target.result); // Push image preview URL
            };
            reader.readAsDataURL(file);
          },   
         FileUpload(){
          this.uploading=true
            let params ={
              storage:this.storage,
              account: this.$session.get('userID'),
              allowed_files:this.allowed_files,
              files: this.accetedFiles,
              date: this.$moment().format('YYYY-MM-DD')
            }
            setTimeout(()=>{
              this.$uploadToS3(params, (res)=>{
                if(res.status == 'Complete') {
                  
                  this.upload_status = 'Complete (' +  res.count +')'
                 
                  setTimeout(()=>{
                    this.uploadedfiles = res.locations
                    this.accetedFiles = []
                    this.imagePreviews = []
                    this.uploading=false
                    this.$emit('zeraEvent', this.uploadedfiles)
                  },2000)
                 
                } else if(res.status == 'File Complete') {
                     this.upload_status = res.count
                } else if(res.status == 'Progress') {
                  this.upload_status = res.progress + '%'
                }
              })
            },1000)
           
         }
       },
     }
   </script>